import React, { useEffect, useState } from 'react'
import UserAdminsList from './admins/UserAdminsList';
import UserVendorsList from './vendors/UserVendorsList';
import InviteExpertTable from './experts/inviteExpertTable';

interface UserTabOptionsProps {
  userTab: string;
}

const UserTabOptions: React.FC<UserTabOptionsProps> = ({ userTab }) => {
  const [alignment, setAlignment] = useState(userTab);
  useEffect(() => {
    if (userTab) {
      setAlignment(userTab);
    }
  }, [userTab]);

  return (
    <div
      style={{
          borderBottom: '1px solid',
          borderColor: '#E8EAEF',
          margin: '0 2px 2px 2px',
          padding: '0px, 24px, 0px, 24px'
      }}
    >

      {["tasker", "reviewer"].includes(alignment) && (
        <InviteExpertTable alignment={alignment} />
      )}

      {alignment === "vendor" && (
        <UserVendorsList />
      )}
      {alignment === "admin" && (
        <UserAdminsList />
      )}
    </div>
  )
}

export default UserTabOptions